// extracted by mini-css-extract-plugin
export default {"sortIcon":"ColumnHeaderSortIcon_sortIcon__AT80m","asc":"ColumnHeaderSortIcon_asc__XcH8H","desc":"ColumnHeaderSortIcon_desc__FggpL"};